<template>
  <div>
    <Head :title="title" />

    <jet-banner />

    <div class="flex flex-col justify-center min-h-screen">
      <!--  bg-CLIENT_PRIMARY_PINK -->
      <nav class="hidden md:block bg-white text-white border-b border-gray-100">
        <!-- Primary Navigation Menu -->
        <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div class="flex justify-center h-16">
            <div class="flex">
              <!-- Navigation Links -->
              <div class="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex">
                <a
                  class="font-bold text-gray-500 text-lg inline-flex items-center px-1 pt-1 border-b-2 border-transparent leading-5 hover:text-gray-700 hover:border-gray-300 transition duration-150 ease-in-out"
                  :href="route('portal.index')">
                  トップページ
                </a>

                <a
                  class="font-bold text-gray-500 text-lg inline-flex items-center px-1 pt-1 border-b-2 border-transparent leading-5 hover:text-gray-700 hover:border-gray-300 transition duration-150 ease-in-out"
                  :href="route('client-top')">
                  全国統一模試
                </a>

                <a
                  class="font-bold text-gray-500 text-lg inline-flex items-center px-1 pt-1 border-b-2 border-transparent leading-5 hover:text-gray-700 hover:border-gray-300 transition duration-150 ease-in-out"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.rinshovet.blog/">
                  オンライン予備校(寺子屋)
                </a>

                <a
                  class="font-bold text-gray-500 text-lg inline-flex items-center px-1 pt-1 border-b-2 border-transparent leading-5 hover:text-gray-700 hover:border-gray-300 transition duration-150 ease-in-out"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://apps.apple.com/jp/app/%E3%81%A9%E3%81%86%E3%81%B6%E3%81%A4%E7%9C%8B%E8%AD%B7%E3%83%9D%E3%83%BC%E3%82%BF%E3%83%AB/id1628987767">
                  どうぶつ看護ポータル(iOS)
                </a>
                <a
                  class="font-bold text-gray-500 text-lg inline-flex items-center px-1 pt-1 border-b-2 border-transparent leading-5 hover:text-gray-700 hover:border-gray-300 transition duration-150 ease-in-out"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://play.google.com/store/apps/details?id=com.vet.animal_portal&hl=bs">
                  どうぶつ看護ポータル(Android)
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <!-- Page Content -->
      <main class="flex-grow">
        <flash-messages />
        <slot></slot>
      </main>

      <div class="text-left">
        <nav
          :class="isOpen ? '-right-0 opacity-100' : '-right-full opacity-0'"
          class="fixed z-10 bg-white top-0 button-0 text-current w-52 h-screen transition-all duration-300">
          <div class="pt-12 px-6">
            <ul class="m-0 p-0 list-none">
              <li class="m-0 border-b-2">
                <a
                  class="block text-gray-600 active:text-gray-300 text-sm p-3 no-underline duration-150"
                  :href="route('index')">
                  トップページ
                </a>
              </li>
              <li class="m-0 border-b-2">
                <a
                  class="block text-gray-600 active:text-gray-300 text-sm p-3 no-underline duration-150"
                  :href="route('portal.information.index')">
                  お知らせ
                </a>
              </li>

              <li
                v-if="isFetchedUserInfo && isLoggedIn"
                class="m-0 border-b-2">
                <a
                  class="block text-gray-600 active:text-gray-300 text-sm p-3 no-underline duration-150"
                  :href="route('client.mypage')">
                  マイページ
                </a>
              </li>
              <li
                v-if="isFetchedUserInfo && isLoggedIn"
                class="m-0 border-b-2">
                <button
                  class="block text-gray-600 active:text-gray-300 text-sm p-3 no-underline duration-150"
                  @click.prevent="logout">
                  ログアウト
                </button>
              </li>

              <li
                v-if="!isFetchedUserInfo || !isLoggedIn"
                class="m-0 border-b-2">
                <button
                  class="block text-gray-600 active:text-gray-300 text-sm p-3 no-underline duration-150"
                  @click.prevent="onSignIn">
                  ログイン
                </button>
              </li>

              <li
                v-if="!isFetchedUserInfo || !isLoggedIn"
                class="m-0 border-b-2">
                <button
                  class="block text-gray-600 active:text-gray-300 text-sm p-3 no-underline duration-150"
                  @click.prevent="onSignUp">
                  無料会員登録
                </button>
              </li>
            </ul>
          </div>
        </nav>
        <div
          :class="isOpen
            ? 'block bg-black w-full h-full top-0 left-0 fixed opacity-80 z-2 cursor-pointer'
            : 'hidden transition-all duration-500'
          "
          @click="toggleBtn"></div>
      </div>

      <!-- <footer class="bg-gray-50 shadow">
        <div class="max-w-7xl flex justify-center md:justify-end text-left text-sm mx-auto py-6 sm:px-4 lg:px-8">
          <div class="text-gray-600 px-2 hover:text-black">
            <a class="block" :href="route('portal.guide.company')">運営会社について</a>
          </div>
          <div class="text-gray-600 px-2">
            <a class="block hover:text-black" :href="route('portal.guide.terms')">利用規約</a>
            <a class="block pt-3 hover:text-black" :href="route('portal.guide.privacy')">プライバシーポリシー</a>
            <a class="block pt-3 hover:text-black" :href="route('portal.guide.asct')">特定商取引法に基づく表記</a>
          </div>
        </div>
      </footer> -->
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { Head, Link, usePage } from '@inertiajs/inertia-vue3'
import firebase from 'firebase/compat/app'
import Swal from 'sweetalert2'
import {
  getAuth,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from 'firebase/auth'
import DialogModal from '../Common/DialogModal.vue'
import JetApplicationMark from '@/Jetstream/ApplicationMark'
import JetBanner from '@/Jetstream/Banner'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import FlashMessages from '@/Common/FlashMessages'
import firebaseApp from '@/Constants/configFirebase'
import 'firebase/compat/auth'
import { EmailRegex } from '@/Constants/regularExpression'
import REGISTER_ERROR_MESSAGES from '@/Constants/registerErrors'
import SIGNIN_ERROR_MESSAGES from '@/Constants/signinErrors'

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
})

const auth = getAuth(firebaseApp)

const isOpen = ref(false)

const isShowSignIn = ref(false)
const isShowSignUp = ref(false)
const isShowResetPassword = ref(false)

const email = ref('')
const password = ref('')
const confirmationPassword = ref('')

const emailFormErrorText = ref('')
const passwordFormErrorText = ref('')
const confirmationPasswordFormErrorText = ref('')
const loginErrorText = ref('')
const signUpErrorText = ref('')
const resetPasswordFormErrorText = ref('')

const isProcessing = ref(false)
const isRegisterEnd = ref(false)

const isLoggedIn = ref(false)
const user = ref()
const isFetchedUserInfo = ref(false)

firebase.auth(firebaseApp).onAuthStateChanged((e) => {
  if (e) {
    isLoggedIn.value = true
    user.value = e
  } else {
    isLoggedIn.value = false
    user.value = null
  }
  isFetchedUserInfo.value = true
})

const actionCodeSettings = {
  // 環境変数の値を読み込む
  url: route('index'),
}

const scrollControl = () => {
  if (isOpen.value) {
    document.documentElement.style.overflow = 'hidden'
  } else {
    document.documentElement.style.overflow = 'auto'
  }
}
const toggleBtn = () => {
  isOpen.value = !isOpen.value
  scrollControl()
}

const clientUserEmail = computed(() => {
  const emailName = usePage().props.value.client.user.email
  return emailName.substring(0, emailName.lastIndexOf('@'))
})

const VerifiedEmailText = computed(() => {
  const isClientVerifiedEmail = usePage().props.value.client.isVerifiedEmail
  return isClientVerifiedEmail ? '認証済' : '未認証'
})

const showingNavigationDropdown = ref(false)

const showMypage = () => {
  Inertia.get(route('client.mypage'))
}

const logout = () => {
  Swal.fire({
    icon: 'question',
    text: 'ログアウトしてよろしいですか？',
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
    confirmButtonColor: '#FF8A80',
  }).then((result) => {
    if (result.isConfirmed) {
      firebase.auth(firebaseApp).signOut()
      Inertia.post(route('clients.logout.post'))
    }
  })
}

const onSignIn = () => {
  isShowSignIn.value = true
}

const onSignUp = () => {
  email.value = ''
  password.value = ''
  confirmationPassword.value = ''
  isShowSignUp.value = true
}

const onResetPassword = () => {
  email.value = ''
  isShowResetPassword.value = true
}

const signUp = () => {
  // 未入力＆フォーマットチェック
  if (!email.value.length) {
    emailFormErrorText.value = REGISTER_ERROR_MESSAGES.emptyEmail
  } else if (!email.value.match(EmailRegex)) {
    emailFormErrorText.value = REGISTER_ERROR_MESSAGES.invalidEmail
  } else {
    emailFormErrorText.value = ''
  }
  if (password.value.length < 6) {
    passwordFormErrorText.value = REGISTER_ERROR_MESSAGES.password
  } else {
    passwordFormErrorText.value = ''
  }
  if (password.value !== confirmationPassword.value) {
    confirmationPasswordFormErrorText.value = REGISTER_ERROR_MESSAGES.confirmationPassword
  } else {
    confirmationPasswordFormErrorText.value = ''
  }

  // ERRORがあれば、処理を中断する
  if (
    emailFormErrorText.value
    || passwordFormErrorText.value
    || confirmationPasswordFormErrorText.value
  ) {
    return false
  }

  // 多重ポストを避ける
  if (isProcessing.value) return false
  isProcessing.value = true

  createUserWithEmailAndPassword(auth, email.value, password.value)
    .then(async () => {
      // 確認用メール送信
      await sendEmailVerification(auth.currentUser, actionCodeSettings)
        .then(async () => {
          await signInWithEmailAndPassword(auth, email.value, password.value)
          const userToken = await auth.currentUser.getIdToken(true)
          const userEmail = auth.currentUser.email
          isRegisterEnd.value = true
          isProcessing.value = false

          Inertia.visit('/login', {
            method: 'post',
            data: {
              email: userEmail,
              password: password.value,
              idToken: userToken,
            },
          })
        })
        .catch((e) => {
          isProcessing.value = false
          signUpErrorText.value = e.code
        })
    })
    .catch((error) => {
      isProcessing.value = false
      if (error.code === 'auth/email-already-in-use') {
        signUpErrorText.value = '既に登録済みのメールアドレスです。'
      } else {
        signUpErrorText.value = error.code
      }
    })
}

const resetPassword = () => {
  if (!email.value.match(EmailRegex)) {
    resetPasswordFormErrorText.value = '登録されているメールアドレスを正しく入力してください。'
    return false
  }
  resetPasswordFormErrorText.value = ''

  // 多重ポストを避ける
  if (isProcessing.value) return false
  isProcessing.value = true

  sendPasswordResetEmail(auth, email.value, actionCodeSettings)
    .then(() => {
      isProcessing.value = false
      isShowResetPassword.value = false
      Swal.fire({
        html: 'パスワード再設定用のメールを送信しました。',
        icon: 'success',
        confirmButtonText: '閉じる',
      })
    })
    .catch((e) => {
      // eslint-disable-next-line no-alert
      alert(e.code)
      isProcessing.value = false
      isShowResetPassword.value = false
      signUpErrorText.value = e.code
      return false
    })
  return undefined
}
</script>
